<template>
  <el-container class="app-wrapper">
    <el-scrollbar>
      <div class="content-wrapper">
        <div class="aside-wrapper">
          <TheSideBar />
          <el-footer>
            <TheFooter />
          </el-footer>
        </div>
        <el-container class="main-wrapper">
          <el-main>
            <RouterView />
          </el-main>
        </el-container>
      </div>
    </el-scrollbar>
  </el-container>
</template>

<script setup lang="ts">
import TheFooter from "@/src/layouts/TheFooter.vue";
import TheSideBar from "@/src/layouts/TheSideBar.vue";

</script>

<style lang="scss" scoped>
.el-footer {
  margin-top: 10rem;
  padding: 0;
  height: auto;
}

.el-main {
  overflow: visible;
}

.aside-wrapper {
  width: 300px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  border-right: 1px solid #dcdfe6;
}

.app-wrapper {
  width: 100vw;
  height: 100vh;

  .content-wrapper {
    display: flex;
    height: 100%;
  }

  .main-wrapper {
    width: calc(100vw - 300px);
  }
}
</style>
